import { FormResponse } from "@tellescope/types-models";
import { HIDDEN_ANSWER_TYPES, renderAnswer } from "../../../../shared/forms";

interface FormAnswerProps {
  title: string;
  answer: NonNullable<FormResponse["responses"]>[number]["answer"];
  answerIsHTML?: boolean;
}

export const FormAnswer = ({ title, answer, answerIsHTML }: FormAnswerProps) => {
  if (HIDDEN_ANSWER_TYPES.includes(answer.type)) return null;

  const renderedAnswer = renderAnswer(answer, answerIsHTML);
  if (!renderedAnswer) return null;

  return (
    <div className="border-b border-border pb-3 last:border-b-0">
      <div className="text-sm font-medium text-muted-foreground mb-1">{title}</div>
      <div className="text-sm text-foreground">{renderedAnswer}</div>
    </div>
  );
};
